import PageBase from 'common/pageBase';
import register from 'component/register/registerLowRate';
import toast from 'component/common/toast.jquery';
import es from 'component/common/es';
import uri from 'component/common/uri';
import wxShare from 'component/common/wxShare_v3';
import {REGISTER_SUBMIT_URL} from 'common/cons';
import {getCardloanH5Url, getCardloanH5LoginUrl} from 'common/urlAddress';
import regconfig from 'component/common/regConfig.js';
import {toutiaoPush, requestToutiao} from '../../../component/common/toutiao';
import {dminit, doumengPush} from '../../../component/common/doumeng';
import {baiduInit , baiduPush} from '../../../component/common/baidu';
import {report} from '../../../component/common/report';
let baidu_url='https://cardloan.xiaoying.com/fe/config/cardloan/landing/lowRate/baidu.json';
let requestToutiaoJsonUrl = 'https://cardloan.xiaoying.com/fe/config/cardloan/landing/lowRate/toutiao.json';
let requestDoumengJsonUrl='https://cardloan.xiaoying.com/fe/config/cardloan/xy-card-loan/doumeng.json';
requestToutiao(requestToutiaoJsonUrl);
dminit(requestDoumengJsonUrl);
baiduInit(baidu_url);
let url = 'https://cardloan.xiaoying.com/fe/config/cardloan/landing/lowRate/config.json';
let _url = 'https://cardloan.xiaoying.com/h5/homepage/get_channel_config';
let configVal = {
  tip: '',
  address: '',
  showRedEnvelope: 0,
  phone: '',
  num: '',
};

class Lowrate extends PageBase {
  constructor() {
    super();
    let sourceParam = {
      source: this.source_
    }
    this.reportInit();
    this.showCaptchabox = true;

    if (this.source_) {
      Promise.all([this.confSend(_url, sourceParam, true), this.confSendGet(url)]).then((data) => {
        if (data[0].errcode == 0) {
          this.showCaptchabox = data[0].data.needCaptchaCode;
        }
        configVal = regconfig(data[1]);
        this.init();
      }).catch((err) => {
        this.init();
      });
    } else {
      this.init();
    }
  }

  init() {
    require('./css/index.css');
    let tpl = require('./index.tpl.html');
    this.$html = $(tpl);
    const node = document.getElementById('container');
    node.innerHTML = '';
    this.appendTo(node);
    let sourceParam = {
      source: uri.getQuery('source') || '',
    };
    let oldUserTip = '当前手机已注册，将会自动跳转至登录页';
    let jumpAddress = getCardloanH5Url(sourceParam);
    let oldUserJumpAddress = getCardloanH5LoginUrl(sourceParam);
    if (configVal.jumpType) {
      if (configVal.jumpType === 'download') {
        oldUserTip = '当前手机已注册，将会自动跳转至下载页';
        jumpAddress = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xiaoying.cardloan';
        oldUserJumpAddress = jumpAddress;
      }
    }
    if (configVal.bgImage) {
      if (configVal.bgImage === 2) {
        this.$html.addClass('_page');
      }
    } else {
      if (configVal.changeText) {
        this.$html.find('.topText').text('仅需4步 当日审批');
      } else {
        this.$html.find('.topText').text('仅需4步 当日审批');
      }
    }
    let registerParams = es.objectAssign({
        btnCheckText: '马上拿钱',
        style: {
          reg_form: {},
          reg_inbox: {},
          reg_in: {},
          reg_captchaimg: {},
          reg_info: {},
          reg_checkbox: {},
          reg_agreeText: {},
          reg_link: {},
          reg_gologin: {},
          reg_btn_submit: {},
        },
        reg_code: 1,
        regSubmitUrl: REGISTER_SUBMIT_URL,
        loginLink: oldUserJumpAddress,
        source: sourceParam.source,
        showCaptchabox: this.showCaptchabox,
        smsOptions: {
          OLD_USER: oldUserTip,
        },

      },
      {
        success: (data, type) => {
          toast('注册成功，即将跳转');
          toutiaoPush();
          doumengPush();
          baiduPush();
          setTimeout(() => {
            $('.rbox .layer').hide();
            window.location.href = jumpAddress;
          }, 2000);
        },
        fail: (data) => {
          if (data.errcode == -2000) {
            setTimeout(() => {
              window.location.href = oldUserJumpAddress;
            }, 2000);
          }
        },
      });
    let registerInstance = register(registerParams);
    registerInstance.appendTo(this.$html.children('.registerbox'));
    if (configVal.showRedEnvelope == 1) {
      let img = $('<div class = "redEnvelope"></div>');
      $('.registerbox').prepend(img);
    }
    let total = 0;
    Object.keys(configVal).forEach((prop) => {
      if (configVal[prop] && (typeof configVal[prop]) === 'string') {
        total++;
      }
    });
    if (total === 0) {
      total = 1;
    }
    $('.page').css({'paddingBottom': (total - 1) * 1.2 + 2 + 'rem'});
    $('#copyright .company').text(configVal.company);
    $('#copyright .address').text(configVal.address);
    if (!configVal.address&& !configVal.tip) {
      $('#copyright .phone').text(configVal.phone);
      $('#copyright .num').text(configVal.num);
    } else {
      $('#copyright .phone').text(configVal.phone + '  ' + configVal.num);
    }
    $('#copyright .tip').text(configVal.tip);
    wxShare.init({
      'buttonImage': 'https://a1.xystatic.com/page/release/xy-operation-website/stable/0.0.0/kadaidaxia.png',//右上角分享icon，如果不需要定制则去掉
      'shareIcon': 'https://a1.xystatic.com/page/release/xy-operation-website/stable/0.0.0/kadaidaxia.png',//分享封面
      'url': window.location.href,//分享链接
      'title': '推荐你使用小赢卡贷：高达6万额度，当日审批！',//分享标题
      'description': '急用钱，快戳我>>',//分享文案
      'platforms': ['0'],//0表示所有系统都能用
      'appVersions': ['0'],//0表示所有版本app都可用
      'isValid': 1,//是否可用
      'scene': [1, 2, 3, 4, 5]//1:微信好友,2:微信朋友圈,3:qzone,4:qq,5微博:6:通讯录邀请,7通讯录分享
    });
  }
}

new Lowrate();



// WEBPACK FOOTER //
// ./src/module/lowRate/index/index.js